import React, { useCallback } from "react";
import { DatePicker } from "@pankod/refine-antd";
import dayjs from "dayjs";
import { ShopSelector } from "./ShopSelector";

const disabledDate = (current: dayjs.Dayjs) =>
  current && current > dayjs().endOf("day");

interface GlobalFiltersProps {
  dateRange: [string, string];
  setDateRange: (range: [string, string]) => void;
  shopCode: string | null;
  setShopCode: (code: string | null) => void;
}

export const GlobalFilters: React.FC<GlobalFiltersProps> = ({
  dateRange,
  setDateRange,
  shopCode,
  setShopCode,
}) => {
  const handleDateChange = useCallback(
    (_: any, dateStrings: [string, string]) => {
      if (dateStrings[0] && dateStrings[1]) {
        setDateRange(dateStrings);
      }
    },
    [setDateRange]
  );

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 16,
        marginBottom: 24,
        alignItems: "center",
      }}
    >
      <DatePicker.RangePicker
        placeholder={["Başlangıç Tarihi", "Bitiş Tarihi"]}
        onChange={handleDateChange}
        defaultValue={[dayjs(dateRange[0]), dayjs(dateRange[1])]}
        disabledDate={disabledDate}
        style={{ width: 300 }}
      />
      <ShopSelector value={shopCode} onChange={setShopCode} />
    </div>
  );
};
